import * as tslib_1 from "tslib";
import addFile from './addFile';
import addItem from './addItem';
import { AttachmentFileType } from 'owa-attachment-common';
import createAttachments from 'owa-mail-compose-store/lib/utils/createAttachments';
export default function addAttachments(viewState, attachments) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var shareableFiles, attachableFiles, _i, attachments_1, attachment;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!attachments) {
                        return [2 /*return*/];
                    }
                    shareableFiles = [];
                    attachableFiles = [];
                    _i = 0, attachments_1 = attachments;
                    _a.label = 1;
                case 1:
                    if (!(_i < attachments_1.length)) return [3 /*break*/, 7];
                    attachment = attachments_1[_i];
                    if (!(attachment.file.fileType == AttachmentFileType.Uri)) return [3 /*break*/, 3];
                    return [4 /*yield*/, addFile(viewState, attachment.file.name, attachment.file.uri, attachment.isInline)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 3:
                    if (!(attachment.file.fileType == AttachmentFileType.MailItem)) return [3 /*break*/, 5];
                    return [4 /*yield*/, addItem(viewState, attachment.file.name, attachment.file.itemId, attachment.isInline)];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    if (attachment.file.fileType == AttachmentFileType.Cloud) {
                        if (attachment.file.providerType === 4 /* Mailbox */) {
                            shareableFiles.push(attachment.file);
                        }
                        else {
                            attachableFiles.push(attachment.file);
                        }
                    }
                    else if (attachment.file.fileType == AttachmentFileType.AttachmentItem) {
                        attachableFiles.push(attachment.file);
                    }
                    _a.label = 6;
                case 6:
                    _i++;
                    return [3 /*break*/, 1];
                case 7:
                    shareableFiles.length > 0 &&
                        createAttachments(shareableFiles, false, viewState, true /* shouldShare */, false /* isHiddenInline */, null);
                    attachableFiles.length > 0 &&
                        createAttachments(attachableFiles, false, viewState, false /* shouldShare */, false /* isHiddenInline */, null);
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=addAttachments.js.map